import { Pause, Play } from "lucide-react";
import { usePlayer } from "@/context/PlayerContext";
import { STATUS_LABELS } from "@/lib/api";

export const Stat = ({ id, label, value, accent }) => (
  <div data-testid={`stat-${id}`} className="rounded-xl border border-white/10 bg-[#12121A] p-6">
    <p className="font-mono text-[11px] tracking-widest text-slate-500">{label.toUpperCase()}</p>
    <p className={`mt-3 font-heading text-4xl font-extrabold ${accent ? "text-[#FF4500]" : "text-white"}`}>{value}</p>
  </div>
);

const tones = {
  pending: "bg-amber-500/15 text-amber-400", approved: "bg-emerald-500/15 text-emerald-400", aired: "bg-emerald-500/15 text-emerald-400",
  rejected: "bg-red-500/15 text-red-400", not_aired: "bg-red-500/15 text-red-400", refunded: "bg-sky-500/15 text-sky-400", none: "bg-white/5 text-slate-400",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex rounded-full px-2.5 py-1 font-mono text-[10px] tracking-wider ${tones[status] || tones.none}`}>
    {(STATUS_LABELS[status] || status).toUpperCase()}
  </span>
);

export const MiniPlay = ({ track, testId }) => {
  const { track: cur, playing, playSingle, toggle } = usePlayer();
  if (!track) return null;
  const active = cur?.id === track.id;
  return (
    <button data-testid={testId} onClick={() => (active ? toggle() : playSingle(track))} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-[#FF4500]" aria-label="Escuchar">
      {active && playing ? <Pause className="h-3.5 w-3.5 fill-white" /> : <Play className="ml-0.5 h-3.5 w-3.5 fill-white" />}
    </button>
  );
};

export const Empty = ({ children }) => <p className="rounded-xl border border-dashed border-white/10 p-10 text-center text-sm text-slate-500">{children}</p>;

export const tabCls = "rounded-full px-4 py-2 text-sm text-slate-400 data-[state=active]:bg-[#FF4500] data-[state=active]:text-white";
export const fieldCls = "border-white/10 bg-[#181824] text-white";
